import { ApiCMSRequest } from "data/ApiCMS";
import { SchemaData, UseUpdateProps } from "./types";
import { useCallback } from "react";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { UPDATE_QUERY, UpdateGql } from "../queries/update";

export default function useUpdate({ queryParam }: UseUpdateProps) {
  const handleSave = useCallback(
    async (state: JsonFormsStateProps<SchemaData>) => {
      const data = state?.data;

      const endDate = new Date(data.endDate)
      const startDate = new Date(data.startDate)

      if (endDate < startDate) {
        throw {
          message: "A Data de final não pode ser antes que a Data inicial",
          errors: [
            {
              instancePath: "/endDate",
              message: "A Data de final não pode ser antes que a Data inicial",
              schemaPath: "/endDate",
              keyword: "endDate",
              params: {},
            },
          ],
        };
      }

      const response = await ApiCMSRequest<UpdateGql>({
        query: UPDATE_QUERY,
        variables: {
          data: {
            ...data,
            id: queryParam,
          },
        },
      });

      if (response?.data?.errors) {
        console.log(response?.data?.errors);
        throw response.data.errors[0];
      }
      if (!response?.data?.data) {
        throw new Error("Ops. Sem resposta!");
      }
      return response;
    },
    [queryParam]
  );

  return {
    handleSave,
  };
}
